// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

class Product {
    render() {
        /**
         * Init product slider
         * */
        this.productSlider()
    }

    productSlider() {
        const swiperThumbs = new Swiper('.slider__product-thumbs', {
            spaceBetween: 15,
            slidesPerView: 3,
            freeMode: true,
            grabCursor: true,
            watchSlidesProgress: true,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
            },
            breakpoints: {
                768: {
                    spaceBetween: 20,
                }
            }
        });
        const swiper = new Swiper('.slider__product', {
            slidesPerView: 1,
            centeredSlides: true,
            zoom: true,
            spaceBetween: 30,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: swiperThumbs,
            }
        })
    }
}

export default Product